export default __webpack_public_path__ + "static/media/roller.876de232.png";